import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { MasterService } from '../services/master.service';

@Injectable()
export class MasterGuard  {

    constructor(private _masterService: MasterService
        , private _router: Router) { }

    // If canActivate, ActivatedRouteSnapshot contains the future route that
    // will be activated and RouterStateSnapshot contains the future RouterState
    // of the application.
    canActivate() {
        if (this._masterService.CurrentModuleAssignment) {
            return true;
        }
        //this._masterService.browserNavBtnPushed = false;
        this._router.navigate(['/courses']);

        // Cancel the current navigation
        return false;
    }
}
